import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CRMOpportunityApiService,
  CreateCrmObjectRequestInterface,
  CreateCrmObjectResponseInterface,
  DeleteCrmObjectRequestInterface,
  GetMultiCrmObjectRequestInterface,
  GetMultiCrmObjectResponseInterface,
  ListCrmObjectsRequestInterface,
  ListCrmObjectsResponseInterface,
  ListFieldOptionsRequestInterface,
  ListFieldOptionsResponseInterface,
  ListFiltersRequestInterface,
  ListFiltersResponseInterface,
  UpdateCrmObjectRequestInterface,
  ValidateCrmObjectResponseInterface,
  GetOpportunityValueSummaryRequestInterface,
  GetOpportunityValueSummaryResponseInterface,
  ValidateCrmObjectRequestInterface,
} from '@vendasta/crm';
import { Observable } from 'rxjs';
import { AbstractCrmObjectService } from './_abstract.service';

@Injectable({ providedIn: 'root' })
export class OpportunityService implements AbstractCrmObjectService {
  constructor(private readonly service: CRMOpportunityApiService) {}

  createCrmObject(request: CreateCrmObjectRequestInterface): Observable<CreateCrmObjectResponseInterface> {
    return this.service.createOpportunity(request);
  }

  deleteCrmObject(request: DeleteCrmObjectRequestInterface): Observable<HttpResponse<null>> {
    return this.service.deleteOpportunity(request);
  }

  validateCrmObject(request: ValidateCrmObjectRequestInterface): Observable<ValidateCrmObjectResponseInterface> {
    return this.service.validateOpportunity(request);
  }
  updateCrmObject(request: UpdateCrmObjectRequestInterface): Observable<HttpResponse<null>> {
    return this.service.updateOpportunity(request);
  }

  listObjects(request: ListCrmObjectsRequestInterface): Observable<ListCrmObjectsResponseInterface> {
    return this.service.listOpportunities(request);
  }

  listObjectsFilters(request: ListFiltersRequestInterface): Observable<ListFiltersResponseInterface> {
    return this.service.listOpportunitiesFilters(request);
  }

  getMultiObject(request: GetMultiCrmObjectRequestInterface): Observable<GetMultiCrmObjectResponseInterface> {
    return this.service.getMultiOpportunity(request);
  }

  listFieldOptions(request: ListFieldOptionsRequestInterface): Observable<ListFieldOptionsResponseInterface> {
    return this.service.listOpportunityFieldOptions(request);
  }

  getValueSummary(
    request: GetOpportunityValueSummaryRequestInterface,
  ): Observable<GetOpportunityValueSummaryResponseInterface> {
    return this.service.getOpportunityValueSummary(request);
  }
}
